import Swiper from 'swiper'

export default function disclosureSlider()
{
  const WRAPPERS = document.querySelectorAll('.mtt-slider-with-disclosure')

  if (WRAPPERS.length) {
    for (let i = 0; i < WRAPPERS.length; i++) {
      const WRAPPER = WRAPPERS[i]

      new DisclosureSlider(WRAPPER)
    }
  }
}

class DisclosureSlider {
  constructor (WRAPPER) {
    this.WRAPPER = WRAPPER
    this.SWIPER = this.WRAPPER.querySelector('.swiper')
    this.NEXT_BUTTONS = this.WRAPPER.querySelectorAll('.swiper-next')
    this.PREV_BUTTONS = this.WRAPPER.querySelectorAll('.swiper-prev')

    if (this.SWIPER) {
      this.addSlider()
    }
  }

  addSlider () {
    this.SWIPER_INSTANCE = new Swiper(this.SWIPER, {
      slidesPerView: 1,
      threshold: 8,
    })

    this.addNavigation()
  }

  addNavigation () {
    this.addSlideNextClick()
    this.addSlidePrevClick()

    if (this.SWIPER_INSTANCE.slides.length <= 1) {
      this.hideAllButtons()
    }

    if (this.SWIPER_INSTANCE.isBeginning) {
      this.addDisabledClassToButtons(this.PREV_BUTTONS)
    }

    this.SWIPER_INSTANCE.on('slideChange', () => {

      if (this.SWIPER_INSTANCE.isBeginning) {
        this.addDisabledClassToButtons(this.PREV_BUTTONS)
      }

      if (!this.SWIPER_INSTANCE.isBeginning) {
        this.removeDisabledClassToButtons(this.PREV_BUTTONS)
      }

      if (this.SWIPER_INSTANCE.isEnd) {
        this.addDisabledClassToButtons(this.NEXT_BUTTONS)
      }

      if (!this.SWIPER_INSTANCE.isEnd) {
        this.removeDisabledClassToButtons(this.NEXT_BUTTONS)
      }
    })
  }

  addSlideNextClick () {
    if (this.NEXT_BUTTONS.length > 0) {
      for (let i = 0; i < this.NEXT_BUTTONS.length; i++) {
        const BUTTON = this.NEXT_BUTTONS[i]

        BUTTON.addEventListener('click', () => {
          this.SWIPER_INSTANCE.slideNext()
        })
      }
    }
  }

  addSlidePrevClick () {
    if (this.PREV_BUTTONS.length > 0) {
      for (let i = 0; i < this.PREV_BUTTONS.length; i++) {
        const BUTTON = this.PREV_BUTTONS[i]

        BUTTON.addEventListener('click', () => {
          this.SWIPER_INSTANCE.slidePrev()
        })
      }
    }
  }

  addDisabledClassToButtons (buttons) {
    if (buttons.length > 0) {
      for (let i = 0; i < buttons.length; i++) {
        const button = buttons[i]

        button.classList.add('swiper-button-disabled')
      }
    }
  }

  removeDisabledClassToButtons (buttons) {
    if (buttons.length > 0) {
      for (let i = 0; i < buttons.length; i++) {
        const button = buttons[i]

        button.classList.remove('swiper-button-disabled')
      }
    }
  }

  hideAllButtons () {
    const allButtonsWrappers = this.WRAPPER.querySelectorAll('.mtt-slider-with-disclosure__swiper-buttons')

    if (allButtonsWrappers.length > 0) {
      for (let i = 0; i < allButtonsWrappers.length; i++) {
        const allButtonsWrapper = allButtonsWrappers[i]

        allButtonsWrapper.classList.add('hide')
      }
    }
  }
}